import { configureStore } from "@reduxjs/toolkit";
import type { Middleware } from "@reduxjs/toolkit";

import authReducer, { setUser, logout } from "./slices/authSlice";
import usersReducer from "./slices/usersSlice";
import { setSentryUser, clearSentryUser } from "../utils/sentry";

const sentryUserMiddleware: Middleware = () => (next) => (action) => {
  const result = next(action);
  if (setUser.match(action)) {
    setSentryUser(action.payload.userId, action.payload.email);
  } else if (logout.match(action)) {
    clearSentryUser();
  }
  return result;
};

export const store = configureStore({

  reducer: {

    auth: authReducer,

    users: usersReducer,

  },

  middleware: (getDefaultMiddleware) =>

    getDefaultMiddleware({

      serializableCheck: false,

    }).concat(sentryUserMiddleware),

});



export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

